import React from 'react';
import { outcomes } from '../data/outcomes';
import { OFFER_ANCHOR } from './constants';
export function ChangeSection() {
  return <section className="bg-white px-4 py-4" data-id="element-25" data-mp="zn94f6f1bqu6">
      <div className="mx-auto max-w-4xl" data-id="element-26" data-mp="lwm4xc1g9wx1">
        <h2 className="mb-2 text-center font-display text-2xl uppercase leading-none tracking-wide sm:text-4xl" data-id="element-27" data-mp="lvkun9s9degd">
          What Will Change
        </h2>
        <div className="grid gap-2 sm:grid-cols-2" data-id="element-28" data-mp="by6frelzgxq6">
          {outcomes.map(outcome => <a key={outcome.title} href={OFFER_ANCHOR} className="rounded-lg border border-brand-line bg-brand-light p-3 shadow-sm transition-colors duration-150 ease-out hover:border-brand-gold" data-id="element-29" data-mp="gx9i2rakwpug">
              <h3 className="font-head text-[14px] font-bold leading-tight text-brand-navy sm:text-lg" data-id="element-30" data-mp="7xe3sdlq8eq7">
                {outcome.title}
              </h3>
              <p className="mt-0.5 text-xs font-medium leading-snug text-brand-muted sm:text-sm" data-id="element-31" data-mp="22acbqqjyezad">
                {outcome.description}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}